import { Calendar } from "primereact/calendar";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useEffect, useState, useRef } from "react";
import { Card } from "primereact/card";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import ProjectService from "./ProjectService";
import { Dropdown } from "primereact/dropdown";
import { FaBars } from "react-icons/fa";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import SlowTrace from "./SlowTrace";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { addLocale } from "primereact/api";
import { getTimeZoneName } from "../../config/helpingFunctions";
import i18n from "i18next";
import { useTranslation } from "react-i18next";
import { MultiSelect } from "primereact/multiselect";
import { saveAs } from 'file-saver';
import { Tooltip } from "react-tooltip";
var JSZip = require("jszip");
var FileSaver = require("file-saver");

type EventProps = {
  userDetails: any;
  openVisualization: (rowData: any) => void;
};

const Event = (props: EventProps) => {
  const toast = useRef<any>(null);
  const { t } = useTranslation();
  const { projectId } = useParams<any>();
  let urlLocation = useLocation();
  const [devices, setDevices] = useState<any>([]);
  const [startDate, setStartDate] = useState<any>();
  const [endDate, setEndDate] = useState<any>();
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [errors, setErrors] = useState<any>("");
  const [viewDialogue, setViewDialogue] = useState<boolean>(false);
  const [isDataLoading, setIsDataLoading] = useState<boolean>(false);
  const [timeZone, setTimeZone] = useState<any>();
  const [tableView, setTableView] = useState<boolean>(true);
  const [slowTraceView, setSlowTraceView] = useState<boolean>(false);
  const [station, setStation] = useState<any>("");
  const [location, setLocation] = useState<any>("Not Available");
  const [network, setNetwork] = useState<any>("Not Available");
  const [time, setTime] = useState<any>("");
  const [firmware, setFirmware] = useState<any>("Not Available");
  const [samplingRate, setSamplingRate] = useState<any>("Not Available");
  const [projectName, setProjectName] = useState<string>("");
  const [unit, setUnit] = useState<any>("");

  const [multiSortMeta, setMultiSortMeta] = useState([]);

  const [did, setDid] = useState<any>({});

  const [deviceId, setDeviceId] = useState<any>("");

  const [device_select, setDeviceSelect] = useState<any>([]);

  const [timeRange, setTimeRange] = useState<any>(1);

  const timeVals = [
    { name: t('last_day'), value: 1 },
    { name: t('last_week'), value: 7 },
    { name: t('last_10_days'), value: 10 },
    { name: t('last_14_days'), value: 14 },
    { name: t('last_month'), value: 30 },
    { name: t('last_2_month'), value: 60 },
    { name: t('custom_time'), value: 0 }
  ];

  addLocale('de', {
    firstDayOfWeek: 1,
    dayNames: ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],
    dayNamesShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
    monthNames: ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    monthNamesShort: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],
    today: 'Heute',
    clear: 'Löschen'
  });

  addLocale('en', {
    firstDayOfWeek: 0,
    dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
    monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    today: 'Today',
    clear: 'Clear'
  });
  const showSuccess = (message: string) => {
    toast.current.show({
      severity: "success",
      summary: "Confirmation Message",
      detail: message,
      life: 3000,
    });
  };
  const showError = (message: string) => {
    toast.current.show({
      severity: "error",
      summary: "Error Message",
      detail: message,
      life: 3000,
    });
  };
  const downloadSingleSeg2 = (rowData: any) => {
    projectService.getSingleSeg2(rowData).then(async (response) => {
      FileSaver.saveAs(response.url);
    });
  };
  const statusBodyTemplate = (rowData: any) => {
    const button_div = (
      <div className="p-formgroup-inline">
        <Button
          icon="pi pi-chart-line"
          className="p-button-danger visualization-button ml-1 lg:ml-0"
          tooltip={t("view_visualization")}
          style={{ width: '2rem', paddingRight: 0, paddingLeft: 0 }}
          onClick={() => {
            props.openVisualization(rowData);
          }}
        />

        <Button
          icon="pi pi-eye"
          className="p-button-secondary device-edit-button mt-2 ml-1"
          tooltip={t("view_details")}
          style={{ width: '2rem', paddingRight: 0, paddingLeft: 0 }}
          onClick={() => viewDetails(rowData)}
        />

        <Button
          icon="pi pi-file-pdf"
          className="p-button-primary device-edit-button mt-2 ml-1"
          style={{ width: '2rem', paddingRight: 0, paddingLeft: 0 }}
          tooltip={t("view_single_report")}
          onClick={() =>
            window.open(
              `/report?did=${rowData["station"]}&str_time=${rowData["start_time_utc"]}&end_time=${rowData["end_time_utc"]}&din=true`,
              "Popup",
              "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=1000, height=600, top=30"
            )
          }
        />
        <Button
          icon="pi pi-download"
          className="p-button-info download-seg2-button mt-2 ml-1"
          tooltip={t("download_seg2")}
          style={{ width: '2rem', paddingRight: 0, paddingLeft: 0 }}
          onClick={() => downloadSingleSeg2(rowData)}
        />
      </div>
    );

    return button_div;
  };

  const projectService = new ProjectService();
  const multipleReport = () => {
    let strtDate, edDate;
    if (startDate === undefined || endDate === undefined) {
      strtDate = setDefaulltDates().previous_date;
      edDate = setDefaulltDates().current_date;
    } else {
      strtDate = Date.parse(startDate) / 1000;
      edDate = Date.parse(endDate) / 1000;
    }
    const projectId = did[0].split('~')[1];
    if (deviceId === false) {
      showError(t('data_station'))
    }
    else if (slowTraceView && deviceId !== false) {
      window.open(
        `/slow-trace-report?did=${deviceId}&str_time=${strtDate}&end_time=${edDate}&projectId=${projectId}`,
        "Popup",
        "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=1000, height=600, top=30"
      );
    }
    else if (!slowTraceView && deviceId !== false) {
      window.open(
        `/event-report?did=${deviceId}&str_time=${strtDate}&end_time=${edDate}&projectId=${projectId}`,
        "Popup",
        "toolbar=no, location=no, statusbar=no, menubar=no, scrollbars=1, resizable=0, width=1000, height=600, top=30"
      );

    }
  };
  const viewDetails = (data: any) => {
    let dev_Id = data["data_id"].split("~");
    projectService
      .getDeviceInfo(dev_Id[0], data["start_time_utc"], data["end_time_utc"])
      .then((response) => {
        setViewDialogue(true);
        setStation(data["station"]);
        setTime(data["time"]);
        setNetwork(response["headerdata"]["network"]);
        setLocation(response["headerdata"]["location"]);
        setFirmware(response["headerdata"]["firmware_version"]);
        setSamplingRate(response["headerdata"]["sampling_rate"]);
      });
  };
  const onDeviceSelect = (evt: any) => {
    setIsDataLoading(true);
    let deviceVal;
    if (slowTraceView) {
      if (evt.value.length > 1) {
        // If more than one option is selected, keep only the last selected option
        deviceVal = [evt.value.pop()]

        setDid(deviceVal);
      } else {
        deviceVal = [evt.value]
        setDid(deviceVal);
      }
    }
    else {
      deviceVal = evt.value
      setDid(evt.value);
    }
    // const strtDate:any = setDefaulltDates().previous_date;
    // const edDate: any = setDefaulltDates().current_date;
    const strtDate: any = new Date(startDate).getTime() / 1000;
    const edDate: any = new Date(endDate).getTime() / 1000;;
    let filter = multiSortMeta[0] === undefined ? false : multiSortMeta[0]
    if (evt.value.length > 0) {
      projectService
        .getDeviceDetails(first, rows, strtDate, edDate, deviceVal, filter)
        .then((response) => {
          const firstUnit =
            response.data["response_arr"].length > 0
              ? response.data["response_arr"][0]["unit"]
              : "";
          const findArr: any = [];
          response.data["response_arr"].filter((item: any) => {
            if (item["unit"] === firstUnit) findArr.push(item);
          });
          if (response.data["response_arr"].length === findArr.length)
            setUnit(firstUnit);
          setTotalRecords(response["totalRecords"]);
          setDevices(response.data["response_arr"]);
          setDeviceId(response["data"]["response_arr"].length > 0 && response["data"]["response_arr"][0]['station'])
          setIsDataLoading(false);
        });
    }
    else
      setIsDataLoading(false);

  };
  const onPageChange = (evt: any) => {
    setIsDataLoading(true);
    const offset = evt.first;
    const limit = evt.rows;
    setFirst(evt.first);
    setRows(evt.rows);
    let strtDate: any, edDate: any;
    if (startDate === undefined && endDate === undefined) {
      strtDate = setDefaulltDates().previous_date;
      edDate = setDefaulltDates().current_date;
    } else {
      strtDate = Date.parse(startDate) / 1000;
      edDate = Date.parse(endDate) / 1000;
    }
    let filter = multiSortMeta[0] === undefined ? false : multiSortMeta[0]

    projectService
      .getDeviceDetails(offset, limit, strtDate, edDate, did, filter)
      .then((response) => {
        const firstUnit =
          response.data["response_arr"].length > 0
            ? response.data["response_arr"][0]["unit"]
            : "";
        const findArr: any = [];
        response.data["response_arr"].filter((item: any) => {
          if (item["unit"] === firstUnit) findArr.push(item);
        });
        if (response.data["response_arr"].length === findArr.length)
          setUnit(firstUnit);
        setTotalRecords(response["totalRecords"]);
        setDevices(response.data["response_arr"]);
        setIsDataLoading(false);
      });
  };
  const setDefaulltDates = () => {
    const timeZone = localStorage.getItem('timezone')!
    const prevDate = new Date();
    prevDate.setDate(prevDate.getDate() - 1);
    const formattedprevDate: any = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(prevDate);

    const now = new Date();
    const currentDate: any = new Intl.DateTimeFormat('en-US', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    }).format(now);
    const strtDate: any = new Date(currentDate);
    const edDate: any = new Date(formattedprevDate);
    const parsedStrtDate = Date.parse(strtDate) / 1000;
    const parsedEndDate = Date.parse(edDate) / 1000;
    if(!localStorage.getItem('eventStrtTime') || !localStorage.getItem('eventEndTime')) {
        setStartDate(new Date(formattedprevDate));
        setEndDate(new Date(currentDate));
    };
    const time_series = {
      current_date: parsedStrtDate,
      previous_date: parsedEndDate,
    };
    return time_series;
  };

  const onSubmit = () => {
    setIsDataLoading(true);
    const strtDate: any = Date.parse(startDate) / 1000;
    const edDate: any = Date.parse(endDate) / 1000;
    if (edDate === strtDate || edDate > strtDate) {
      setErrors("");
      localStorage.setItem("strtDate", strtDate);
      localStorage.setItem("edDate", edDate);
      let filter = multiSortMeta[0] === undefined ? false : multiSortMeta[0]

      projectService
        .getDeviceDetails(first, rows, strtDate, edDate, did, filter)
        .then((response) => {
          setTotalRecords(response["totalRecords"]);
          setDevices(response.data["response_arr"]);
          setIsDataLoading(false);
        });
    } else {
      setErrors(t('correct_date'));
    }
  };

  const downloadMultipleSeg2 = () => {
    let strtDate, edDate;
    if (startDate === undefined || endDate === undefined) {
      strtDate = setDefaulltDates().previous_date;
      edDate = setDefaulltDates().current_date;
    } else {
      strtDate = Date.parse(startDate) / 1000;
      edDate = Date.parse(endDate) / 1000;
    }
    if (!slowTraceView) {
      let apiType;
      if (totalRecords > 500) {
        apiType = "onEmail";
      } else {
        apiType = "onServer";
      }
      projectService
        .getMultipleSeg2(did, strtDate, edDate, apiType)
        .then(async (response) => {
          if (response["data"].length > 0) {
            showSuccess(t("file_downloaded"));
            const zip = new JSZip();
            await Promise.all(
              response["data"].map((res: any) => {
                const blobPromise = fetch(res["url"]).then((r) => {
                  if (r.status === 200) {
                    return r.blob();
                  }
                  return Promise.reject(new Error(r.statusText));
                });
                const name = res["filename"];
                zip.file(name, blobPromise);
              })
            );
            zip.generateAsync({ type: "blob" }).then((blob: any) => {
              saveAs(blob, "seg2_files.zip");
            });
          } else {
            showSuccess(t('email_check'));
          }
        });
    }
    else {
      showSuccess(t("file_downloaded"));
      const filename = `${did[0].split('~')[0]}_${strtDate}_${edDate}.csv`
      projectService.downloadSlowTraceCSV(did, strtDate, edDate).then(response => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);

        // Trigger the click event on the <a> element to start the download
        link.click();

        // Clean up the URL and remove the <a> element
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      })
    }
  };

  const getDeviceDetails = (devId: any) => {
    setIsDataLoading(true);
    let strtDate: any;
    let edDate: any;
    const storageStrtDate = localStorage.getItem('eventStrtTime');
    const storageEndDate = localStorage.getItem('eventEndTime');
    if(storageStrtDate)
        strtDate = storageStrtDate;
    else
        strtDate = setDefaulltDates().previous_date;
    if(storageEndDate)
        edDate = storageEndDate;
    else
        edDate = setDefaulltDates().current_date;

    localStorage.setItem("strtDate", strtDate);
    localStorage.setItem("edDate", edDate);
    projectService
      .getDeviceDetails(0, 10, strtDate, edDate, devId, false)
      .then((response) => {
        const firstUnit =
          response.data["response_arr"].length > 0
            ? response.data["response_arr"][0]["unit"]
            : "";
        const findArr: any = [];
        response.data["response_arr"].filter((item: any) => {
          if (item["unit"] === firstUnit) findArr.push(item);
        });
        if (response.data["response_arr"].length === findArr.length)
          setUnit(firstUnit);
        setTotalRecords(response["totalRecords"]);
        setDevices(response["data"]["response_arr"]);
        setDeviceId(response["data"]["response_arr"].length > 0 && response["data"]["response_arr"][0]['station'])
        setIsDataLoading(false);

      });
  };

  useEffect(() => {
    setIsDataLoading(true);
    localStorage.setItem("tabVal", 'events');
    i18n.changeLanguage(localStorage.getItem("lang")!);
    const timezone = getTimeZoneName();
    setTimeZone(timezone);
    let arr: any = [];
    if (projectId === undefined) {
      projectService
        .getAssignedDevices(props.userDetails["id"], 'all-stations')
        .then((response) => {
          setProjectName(t("all_projects"));
          response.map((project: any) => {
            project["project_devices"].map((device: any) => {
              let json = {
                name: `${device["station"]} | ${project['project']['project_name']}`,
                value: `${device["station"]}~${device['project_id']}`,
              };
              arr.push(json);
            });
          });
          let devId: any;
          const localEventSelect = localStorage.getItem('eventSelect');
          const localEventsList = localStorage.getItem('eventsList');
          if(localEventsList){
              setDid(JSON.parse(localEventsList));
              getDeviceDetails(JSON.parse(localEventsList));

          }
          else if (localEventSelect) {
              const did = JSON.parse(localEventSelect);
              if (did && did["value"]) {
                devId = did;
              } else {
                devId = arr[0];
              }
          }
          else{
            if (!did["value"]) devId = arr[0];
            else devId = did["value"];
          }

          if (devId !== undefined) {
            setDid([devId['value']]);
            getDeviceDetails(devId['value']);
          }
          setDeviceSelect(arr);
          setIsDataLoading(false);
        });
    }
    else {
      projectService
        .getSingleAssignedDevice(projectId, props.userDetails["id"], "events")
        .then((response) => {
          setProjectName(response["project"]["project_name"]);
          response["project_devices"].map((device: any) => {
            let json = {
              name: `${device["station"]} | ${response["project"]["project_name"]}`,
              value: `${device["station"]}~${device['project_id']}`,
            };
            arr.push(json);
          });
          let devId: any;
          const localEventSelect = localStorage.getItem('eventSelect');
          const localEventsList = localStorage.getItem('eventsList');
          if(localEventsList){
              setDid(JSON.parse(localEventsList));
              getDeviceDetails(JSON.parse(localEventsList));

          }
          else if (localEventSelect) {
            const did = JSON.parse(localEventSelect);
            if (did && did["value"]) {
              devId = did;
            } else {
              devId = arr[0];
            }
          }
          else{
            if (!did["value"]) devId = arr[0];
            else devId = did["value"];
          }
          setDid([devId['value']]);
          getDeviceDetails(devId['value']);
          setDeviceSelect(arr);
          setIsDataLoading(false);
        });
    };

    const savedStartTime = localStorage.getItem('eventStrtTime');
    if (savedStartTime) {
        const savedDate = new Date(parseInt(savedStartTime, 10) * 1000);
        setStartDate(savedDate);
        setTimeRange(0);
    };
    const savedEndTime = localStorage.getItem('eventEndTime');
    if (savedEndTime) {
        const savedDate = new Date(parseInt(savedEndTime, 10) * 1000);
        setEndDate(savedDate);
        setTimeRange(0);
    };
  }, [urlLocation.pathname, i18n.language]);

  const onSort = (event: any) => {
    setMultiSortMeta(event.multiSortMeta);
    let strtDate: any, edDate: any;
    if (startDate === undefined && endDate === undefined) {
      strtDate = setDefaulltDates().previous_date;
      edDate = setDefaulltDates().current_date;
    } else {
      strtDate = Date.parse(startDate) / 1000;
      edDate = Date.parse(endDate) / 1000;
    }
    let filter = event.multiSortMeta.length > 0 ? event.multiSortMeta[0] : false
    projectService
      .getDeviceDetails(first, rows, strtDate, edDate, did, filter)
      .then((response) => {
        const firstUnit =
          response.data["response_arr"].length > 0
            ? response.data["response_arr"][0]["unit"]
            : "";
        const findArr: any = [];
        response.data["response_arr"].filter((item: any) => {
          if (item["unit"] === firstUnit) findArr.push(item);
        });
        if (response.data["response_arr"].length === findArr.length)
          setUnit(firstUnit);
        setTotalRecords(response["totalRecords"]);
        setDevices(response.data["response_arr"]);
      });
  };


  const customSelectedItemsLabel = () => {
    if (!did || did.length === 0) {
      return 'Select cities';
    }

    const selectedCount = did.length;
    if (selectedCount === 1) {
      return `${selectedCount} ${t('item_selected')}`;
    } else {
      return `${selectedCount} ${t('item_selected')}`;
    }
  };

  const projectBody = (rowData: any) => {
    if (rowData['project'].length > 10) {
      return <>
        <Tooltip id={`project-col`} />
        <p data-tooltip-id={`project-col`}
          data-tooltip-content={rowData['project']}>{rowData['project'].slice(0, 10)}...</p>
      </>;
    }
    else {
      return `${rowData['project']}`
    }
  }

  const stationBody = (rowData: any) => {
    if (rowData['station_name'].length > 10) {
      return <>
        <Tooltip id={`station-col`} />
        <p data-tooltip-id={`station-col`}
          data-tooltip-content={rowData['station_name']}>{rowData['station_name'].slice(0, 10)}...</p>
      </>;
    }
    else {
      return `${rowData['station_name']}`
    }
  }

  const assignNumbers = (field: string, body: any) => {
    return (<>
      <p style={{ textAlign: 'right' }}>{body[field]}</p>
    </>)
  }

  let headerGroup = (
    <ColumnGroup>
      <Row>
        <Column field="start_time" header={t("date_time") + ` [${timeZone}]`} rowSpan={3} sortable />
        <Column header={t("project")} rowSpan={3} />
        <Column header={t("station")} rowSpan={3} />

        <Column className="center-label" header={t("max_amplitudes") + `[${unit}]`} colSpan={5} />
        <Column className="center-label" header={t("dom_frequencies") + ' [Hz]'} colSpan={2} />
        <Column field="options" body={statusBodyTemplate} colSpan={5} />
      </Row>


      <Row>
        <Column field="max" header="|MAX|" sortable />
        <Column field="vector_sum" header="|VR|" sortable />
        <Column header="X" field="max_X" sortable />
        <Column header="Y" field="max_Y" sortable />
        <Column header="Z" field="max_Z" sortable />
        <Column header="X" field="frequency_X" sortable />
        <Column header="Y" field="frequency_Y" sortable />
        <Column header="Z" field="frequency_Z" sortable />
      </Row>
    </ColumnGroup>
  );
  return (
    <>
      <Card
        // title={getDropdown}
        style={{ margin: "0.5em auto", overflowX: "auto" }}
        className="event-container"
      >
        <Toast ref={toast} />
        <div className="grid topEventBar text-center align-items-center">
          <div className="xl:col-3 my-2">
            <div className="flex align-items-center multi-select">
              <div style={{ minWidth: '70px', textAlign: 'left' }}><label style={{ fontSize: '16px', fontWeight: 700 }}>Station</label></div>
              <MultiSelect style={{ width: '100%' }} value={did} onChange={(e) => {
                  if(e.value.length > 1){
                      localStorage.removeItem("eventSelect");
                  }
                  localStorage.setItem('eventsList', JSON.stringify(e.value));
                  onDeviceSelect(e)
              }} options={device_select}
                optionLabel="name" maxSelectedLabels={1} selectedItemsLabel={customSelectedItemsLabel()}
              />
            </div>

          </div>
          <div className="xl:col-5 my-2 responsiveDates">
            <div className='flex align-items-center flex-wrap'>
              <div className="my-2">
                <label htmlFor="range" className="time-select ">
                  {t("from")}
                </label>
                <Calendar
                  className="pl-2"
                  value={startDate}
                  onChange={(e: any) => {
                    setStartDate(e.value);
                    if(e.value) {
                        const strTime: any = (new Date(e.value).getTime()) / 1000
                        localStorage.setItem('eventStrtTime', strTime)
                    }
                    setTimeRange(0);
                  }}
                  showTime
                  showSeconds
                  dateFormat={localStorage.getItem('lang') === 'en' ? 'dd/mm/yy' : 'dd.mm.yy'}
                  maxDate={endDate || new Date("01/01/30000")}
                  locale={localStorage.getItem('lang') === 'en' ? 'en' : 'de'}
                />
              </div>
              <div className="my-2">
                <label htmlFor="range" className="time-select ml-1">
                  {t("to")}{" "}
                </label>
                <Calendar
                  value={endDate}
                  onChange={(e: any) => {
                    setEndDate(e.value);
                    if(e.value) {
                        const endTime: any = new Date(e.value).getTime() / 1000
                        localStorage.setItem('eventEndTime', endTime)
                    }
                    setTimeRange(0);
                  }}
                  showTime
                  showSeconds
                  dateFormat={localStorage.getItem('lang') === 'en' ? 'dd/mm/yy' : 'dd.mm.yy'}
                  minDate={startDate || new Date("01/01/01")}
                  locale={localStorage.getItem('lang') === 'en' ? 'en' : 'de'}
                />
              </div>
            </div>

          </div>
          <div className="xl:col-4 my-2 responsiveDates">
            <div className='flex align-items-center flex-wrap'>
              <Dropdown
                value={timeRange}
                options={timeVals}
                style={{ width: '180px', marginLeft: '10px' }}
                onChange={(e) => {
                  setTimeRange(e.value);
                  const prevDate = new Date();
                  prevDate.setDate(prevDate.getDate() - e.value);
                  const timeZone = localStorage.getItem('timezone')!;
                  const formattedprevDate: any = new Intl.DateTimeFormat('en-US', {
                    timeZone,
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false,
                  }).format(prevDate);
                  setStartDate(new Date(formattedprevDate))
                  setEndDate(new Date());
                }} optionLabel="name">

              </Dropdown>
              <Button
                label={t("search")}
                className="ml-2 time-select-btn p-button-sm mt-1"
                onClick={() => onSubmit()}
              />
            </div>
          </div>
        </div>
        <div className={'mb-3 flex align-items-baseline justify-content-end'}>
          <Button
            style={{ cursor: did.length === 1 ? 'pointer' : 'no-drop', opacity: did.length === 1 ? 1 : 0.5 }}
            icon="pi pi-file-pdf"
            className="p-button-primary device-edit-button"
            tooltip={t("download_report")}
            onClick={() => { did.length === 1 && multipleReport() }}
          />
          <Button
            style={{ cursor: did.length === 1 ? 'pointer' : 'no-drop', opacity: did.length === 1 ? 1 : 0.5 }}
            icon="pi pi-download"
            className="p-button-info download-seg2-button ml-2"
            tooltip={t("download_zip")}
            onClick={() => { did.length === 1 && downloadMultipleSeg2() }}
          />
          <ul className="profile-wrapper inline">
            <li>
              <div className="profile event">
                <a className="name">
                  <FaBars />
                </a>
                <ul className="menu event event-menu">
                  <li>
                    <p
                      onClick={() => {
                        setTableView(true);
                        setSlowTraceView(false);
                      }}
                    >
                      {t("list_view")}
                    </p>
                  </li>

                  <li style={{ cursor: did.length === 1 ? 'pointer' : 'no-drop', opacity: did.length === 1 ? 1 : 0.5 }} >
                    <p
                      onClick={() => {
                        if (did.length === 1) {
                          setTableView(false);
                          setSlowTraceView(true);
                        }
                      }}
                    >
                      {t("slow_trace")}
                    </p>
                  </li>
                  <li>
                    <p>{t("norm")}</p>
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
        <p className="error-message">{errors}</p>

        {tableView ? <>
          <DataTable
            value={devices}
            lazy
            paginator
            headerColumnGroup={headerGroup}
            responsiveLayout="scroll"
            onPage={(event) => onPageChange(event)}
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
            rows={rows}
            first={first}
            rowsPerPageOptions={[10, 15, 20]}
            totalRecords={totalRecords}
            rowHover
            sortMode="multiple"
            removableSort
            dataKey={"vr"}
            onSort={onSort}
            multiSortMeta={multiSortMeta}
            emptyMessage={t("no_data")}
            loading={isDataLoading}

          >
            <Column field="start_time" />
            <Column field="project" body={projectBody} />
            <Column field="station_name" body={stationBody} />
            <Column field="max" body={(rowData) => assignNumbers('max', rowData)} />
            <Column field="vector_sum" body={(rowData) => assignNumbers('vector_sum', rowData)} />
            <Column field="max_X" body={(rowData) => assignNumbers('max_X', rowData)} />
            <Column field="max_Y" body={(rowData) => assignNumbers('max_Y', rowData)} />
            <Column field="max_Z" body={(rowData) => assignNumbers('max_Z', rowData)} />
            <Column field="frequence_X" body={(rowData) => assignNumbers('frequence_X', rowData)} />
            <Column field="frequence_Y" body={(rowData) => assignNumbers('frequence_Y', rowData)} />
            <Column field="frequence_Z" body={(rowData) => assignNumbers('frequence_Z', rowData)} />
            <Column field="options" body={statusBodyTemplate} />
          </DataTable>
        </> : (
          <></>
        )}

        {slowTraceView ? (
          <SlowTrace
            did={did}
            start_time={localStorage.getItem("strtDate")}
            end_time={localStorage.getItem("edDate")}
          />
        ) : (
          <></>
        )}

        <Dialog
          header={t("device_detail")}
          visible={viewDialogue}
          onHide={() => setViewDialogue(false)}
        >
          <div style={{ textAlign: "center" }}>
            <p>
              {t("device_id")}: <span className="device-detail">{station}</span>
            </p>
            <p>
              {t("network_name")} :{" "}
              <span className="device-detail">{network}</span>
            </p>
            <p>
              {t("location")}: <span className="device-detail">{location}</span>
            </p>

            <p>
              {t("start_time")}: <span className="device-detail">{time}</span>
            </p>
            <p>
              {t("firmware_version")}:{" "}
              <span className="device-detail">{firmware}</span>
            </p>
            <p>
              {t("sampling_rate")}:{" "}
              <span className="device-detail">{samplingRate} Hz</span>
            </p>
          </div>
        </Dialog>
      </Card>
    </>
  );
};

export default Event;
